export default __webpack_public_path__ + "static/dr-041ad0938cc1859a8a276e5cf98d7e85.png";